import EditorialLayout, { editorialStyles as styles } from '../components/EditorialLayout'

export default function Contact() {
  return (
    <EditorialLayout
      title='Contact Guitar-Tuner.org'
      description='Contact the Guitar-Tuner.org team with support questions, privacy requests, corrections, partnership enquiries, or feedback about the online tuner.'
      path='/contact'
      eyebrow='Contact'
    >
      <h2>How to reach us</h2>
      <p>
        Email us at{' '}
        <a href='mailto:team@guitar-tuner.org'>team@guitar-tuner.org</a>. Please
        include the page you were using, your device and browser, and a short
        description of the issue when requesting technical support. Do not send
        passwords, payment details, or other sensitive information.
      </p>

      <div className={styles.callout}>
        <p>
          <strong>Privacy requests:</strong> use the subject line “Privacy
          request” so we can identify requests concerning access, correction,
          deletion, objection, or withdrawal of consent.
        </p>
      </div>

      <h2>What you can contact us about</h2>
      <ul>
        <li>problems using the microphone or tuner;</li>
        <li>incorrect tuning information or article corrections;</li>
        <li>privacy and personal-data requests;</li>
        <li>advertising or partnership enquiries; and</li>
        <li>general feedback about Guitar-Tuner.org.</li>
      </ul>

      <h2>Company details</h2>
      <p>
        <strong>ChordChord OÜ</strong><br />
        Sepapaja 6<br />
        Tallinn 15551<br />
        Estonia
      </p>

      <h2>Before contacting support</h2>
      <p>
        If the microphone does not start, confirm that you are using the HTTPS
        version of the website and that microphone permission is enabled for
        Guitar-Tuner.org. You can also use the reference notes to tune by ear
        without microphone access.
      </p>
      <p>
        For information about personal data and cookies, read our{' '}
        <a href='/privacy-policy'>Privacy Policy</a>.
      </p>
    </EditorialLayout>
  )
}
